import './RouteThumbnail.scss'

import React from 'react'

/**
 * Thumbnail with fallback for routes.
 * @param {Object} props
 * @param {string} [props.image] Thumbnail image of the route
 * @param {string} props.alt Alternative text for the image
 */
const RouteThumbnail = ({ image, alt }) => image ? (
    <img className="route-thumbnail" src={image} alt={alt} width={330} height={150} loading='lazy' />
) : (
    <div className="route-thumbnail">
        <i className="i-route text-secondary" title={alt}></i>
    </div>
)

export default RouteThumbnail
